import styles from "../styles.module.scss";
import { useAppData } from "../../context/Contexts";
import { useQuery } from "@tanstack/react-query";
import React, { useState, useEffect } from "react";
import fetchCheck from "../../services/CheckService";
import useCustomProductQuery from "../../services/CustomProductService";
import { slugify } from "../../helpers/helpers";
import SuperOffer from "../SuperOffer";

function getDefaultModel(
  currentAppData,
  model: string | undefined | null,
  models,
) {
  let model1 = model;
  if (currentAppData?.modelTemp) {
    model1 = currentAppData?.modelTemp;
  }
  if (window.scs_force_custom) {
    return "";
  }
  //console.log("model1:", model1);
  return model1;

  if (model1 === null || model1 === undefined) {
    return "";
  }
  if (!(models && models.data)) {
    return "";
  }
  if (typeof models.data[model1] !== "undefined") {
    return model1;
  }
  return "";
}

export default function Step1(props) {
  const { currentAppData, setCurrentAppData } = useAppData();
  const [disabledMakes, setDisabledMakes] = useState<boolean>(true);
  const [disabledModels, setDisabledModels] = useState<boolean>(true);
  const [showTrims, setShowTrims] = useState<boolean>(false);
  const [trims, setTrims] = useState<object>({});
  const [canMoveToStep2, setCanMoveToStep2] = useState<boolean>(false);

  const {
    custom_status,
    custom_data,
    custom_error,
    custom_isFetching,
    custom_refetch,
  } = useCustomProductQuery();

  let type = "normal";
  if (window?.is_real_truck) {
    type = "realtruck";
  } else if (window?.scs_force_custom) {
    type = "custom";
  } else if (window?.scs_custom_endpoint) {
    type = "custom_endpoint";
  }

  const fetchYears = async () => {
    const year = currentAppData?.year;
    const make = currentAppData?.make;
    const model = currentAppData?.model;
    const trim = currentAppData?.trim;

    let query = `?type=${type}`;
    if (window.scs_use_optgroup) {
      query += `&with_sales=yes`;
    }
    if (make && model && year) {
      query += `&make=${make}&model=${model}&year=${year}&trim=${trim}`;
    }
    // console.log(make, model, year, query);
    const urlYears = "https://scsbiz.wearevisum.com/api/v1/years" + query;
    const response = await fetch(urlYears, {
      mode: "cors",
      headers: { "Access-Control-Allow-Origin": "*" },
    }).catch((error) => console.log("error", error));

    const data = await response?.json();

    return data.years;
  };
  const fetchMakes = async () => {
    const year = currentAppData?.year;
    if (!year) return [];
    let query = `?year=${year}&type=${type}`;
    if (window.scs_use_optgroup) {
      query += `&with_sales=yes`;
    }
    const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
    const response = await fetch(urlMakes, {
      mode: "cors",
      headers: { "Access-Control-Allow-Origin": "*" },
    }).catch((error) => console.log("error", error));

    const data = await response?.json();
    if (data.makes.length > 0) {
      setDisabledMakes(false);
    }
    if (window.scs_use_optgroup) {
      return data.makes;
    }
    return data.makes.sort();
  };
  const fetchModels = async () => {
    const year = currentAppData?.year;
    const make = currentAppData?.make;
    if (!year) return [];
    if (!make) return [];
    let query = `?year=${year}&make=${make}&type=${type}`;
    if (window.scs_use_optgroup) {
      query += `&with_sales=yes`;
    }
    const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
    const response = await fetch(urlMakes, {
      mode: "cors",
      headers: { "Access-Control-Allow-Origin": "*" },
    }).catch((error) => console.log("error", error));

    const data = await response?.json();
    // console.log('models', data)
    if (Object.values(data.models).length > 0) {
      setDisabledModels(false);
    }

    if (window.scs_force_normal) {
      setTrims(data.trims2 ? data.trims2 : null);
    } else {
      setTrims(data.trims2 ? data.trims2 : null);
    }

    setCurrentAppData((prevState) => {
      return { ...prevState, trims: data.trims2 ?? null };
    });

    if (data.trims2) {
      const queryParameters = new URLSearchParams(window.location.search);

      let model = getDefaultModel(
        currentAppData,
        window.sessionStorage.getItem("user_model") ?? null,
        { data: data.models },
      );
      if (queryParameters.get("user_model")) {
        model = getDefaultModel(
          currentAppData,
          queryParameters.get("user_model") ?? null,
          { data: data.models },
        );
      }
      if (queryParameters.get("model")) {
        model = getDefaultModel(
          currentAppData,
          queryParameters.get("model") ?? null,
          { data: data.models },
        );
      }

      if (model && model != "") {
        if (Object.keys(data.trims2).length === 0) {
          setCanMoveToStep2(true);
        } else {
          if (typeof data.trims2[model] === "undefined") {
            setCanMoveToStep2(true);
          } else {
            setCanMoveToStep2(false);
          }
        }
      }
    }

    if (window.scs_use_optgroup) {
      return Object.values(data.models);
    }
    return Object.values(data.models).sort();
  };

  // useEffect(() => {
  //     if (currentAppData?.trims) {
  //         const queryParameters = new URLSearchParams(window.location.search)
  //
  //         let model = window.sessionStorage.getItem("user_model") ?? null;
  //         if (queryParameters.get("user_model")) {
  //             model = queryParameters.get("user_model") ?? null;
  //         }
  //         if (queryParameters.get("model")) {
  //             model = queryParameters.get("model") ?? null;
  //         }
  //
  //         const tt = getTrims(model);
  //         if (model && tt.length === 0) {
  //
  //             setTimeout(function () {
  //                 let newStep = 2;
  //                 setCurrentAppData(prevState => {
  //                     return {...prevState, step: newStep}
  //                 });
  //             }, 1500)
  //
  //         }
  //     }
  // }, [currentAppData?.trims]);

  useEffect(() => {
    const tt = getTrims(currentAppData?.model);
    runCheckNow(
      currentAppData?.model,
      tt.length == 1 ? tt[0] : "",
      tt.length > 0,
    );
  }, [trims]);

  const yearsQuery = useQuery({ queryKey: ["years"], queryFn: fetchYears });

  const makesQuery = useQuery({
    queryKey: [`makes-${currentAppData?.year}`],
    queryFn: fetchMakes,
  });

  const modelsQuery = useQuery({
    queryKey: [`models-${currentAppData?.year}-${currentAppData?.make}`],
    queryFn: fetchModels,
  });

  const handleYearChange = (e) => {
    setTrims([]);
    setShowTrims(false);
    setCurrentAppData((prevState) => {
      return {
        ...prevState,
        year: e.target.value,
        make: "",
        model: "",
        trim: "",
        has_trims: false,
        has_cabs: false,
      };
    });
  };

  const handleMakeChange = (e) => {
    setTrims([]);
    setShowTrims(false);
    setCurrentAppData((prevState) => {
      return {
        ...prevState,
        make: e.target.value,
        model: "",
        trim: "",
        has_trims: false,
        has_cabs: false,
      };
    });
  };

  async function runCheckNow(
    value: string | undefined,
    trim: string | undefined,
    has_trims: boolean,
  ) {
    const check = await runCheck(value, trim);
    // console.log('runCheckNow', value, trim, has_trims)
    // console.log('runCheckNow trims', trims);
    // console.log('runCheckNow trims', getTrims(value).length > 0, hasCabSizes(value));

    if (
      check.compatibility_custom !== "N" &&
      window.scs_force_normal !== true &&
      window.is_real_truck !== true
    ) {
      //alert('Need to get custom product via graphql and show the options for custom product');
      if (window.scs_force_custom !== true) {
        const product = await getCustomProduct(value, "");
        setCurrentAppData((prevState) => {
          return {
            ...prevState,
            product: product,
            check: check,
            trim: trim,
            has_trims: getTrims(value).length > 0,
            has_cabs: hasCabSizes(value),
          };
        });
      }
      //product.images = currentAppData?.originalProduct?.images;
      setCurrentAppData((prevState) => {
        return {
          ...prevState,
          check: check,
          trim: trim,
          has_trims: getTrims(value).length > 0,
          has_cabs: hasCabSizes(value),
        };
      });
      return;
    }
    setCurrentAppData((prevState) => {
      return {
        ...prevState,
        check: check,
        trim: trim,
        has_trims: getTrims(value).length > 0,
        has_cabs: hasCabSizes(value),
      };
    });
    return;
  }

  function hasCabSizes(model) {
    if (typeof trims[model] === "undefined") {
      return false;
    }
    return (
      [
        ...new Set(
          trims[model].map((item) => item.cab).filter((item) => item != ""),
        ),
      ].length > 0
    );
  }

  function getCabSizes(model, trim) {
    if (typeof trims[model] === "undefined") {
      return [];
    }
    return [
      ...new Set(
        trims[model]
          .filter((item) => item.trim == trim)
          .map((item) => item.cab),
      ),
    ];
  }

  async function runCheckNowWithCabSize(
    value: string | undefined,
    trim: string | undefined,
    cabSize: string | undefined,
    has_trims: boolean,
    has_cab_sizes: boolean,
  ) {
    const check = await runCheck(value, trim, cabSize);
    console.log("runCheckNowWithCabSize", currentAppData);
    if (
      check.compatibility_custom !== "N" &&
      window.scs_force_normal !== true &&
      window.is_real_truck !== true
    ) {
      //alert('Need to get custom product via graphql and show the options for custom product');
      if (window.scs_force_custom !== true) {
        const product = await getCustomProduct(value, "");
        setCurrentAppData((prevState) => {
          return {
            ...prevState,
            product: product,
            check: check,
            trim: trim,
            has_trims: has_trims,
            cab: cabSize,
            has_cabs: hasCabSizes(currentAppData.model),
          };
        });
      }
      //product.images = currentAppData?.originalProduct?.images;
      setCurrentAppData((prevState) => {
        return {
          ...prevState,
          check: check,
          trim: trim,
          has_trims: has_trims,
          cab: cabSize,
          has_cabs: hasCabSizes(currentAppData.model),
        };
      });
      return;
    }
    setCurrentAppData((prevState) => {
      return {
        ...prevState,
        check: check,
        trim: trim,
        has_trims: has_trims,
        cab: cabSize,
        has_cabs: hasCabSizes(currentAppData.model),
      };
    });
    return;
  }

  async function runTrims(mm) {
    // console.log('mm:', mm);
    if (trims && typeof trims[mm] !== "undefined" && trims[mm].length === 1) {
      await runCheckNow(mm, trims[mm][0].trim, true);
    }
  }

  function getTrims(model) {
    if (typeof trims[model] === "undefined") {
      return [];
    }
    return [
      ...new Set(
        trims[model].map((item) => item.trim).filter((item) => item != ""),
      ),
    ].sort();
  }

  useEffect(() => {
    if (canMoveToStep2) {
      setTimeout(function () {
        const newStep = 2;
        console.log("newStep: ", newStep);

        setCurrentAppData((prevState) => {
          return { ...prevState, step: newStep };
        });
      }, 1000);
    }
  }, [canMoveToStep2]);

  async function runHandleModelChange(value) {
    await setCurrentAppData((prevState) => {
      return { ...prevState, model: value, trim: "" };
    });

    if (currentAppData?.year && currentAppData?.make && value) {
      /*if (
        window.location.href.includes("seatcoversolutions.com") &&
        !window.location.href.includes("/pages/jeep-landing-page") &&
        currentAppData?.make === "Jeep" &&
        ["Wrangler 2-Door", "Wrangler 4-Door"].includes(value)
      ) {
        window.location.href = `https://www.seatcoversolutions.com/pages/jeep-landing-page?make=${currentAppData?.make}&model=${value}&year=${currentAppData?.year}`;
        return;
      }*/

      console.log("trims", trims);

      //DONE: Run compat check on backend and save compatibility information
      console.log(
        "trims check",
        value,
        typeof trims[value] !== "undefined",
        trims[value],
      );
      if (
        trims &&
        typeof trims[value] !== "undefined" &&
        trims[value].length > 0
      ) {
        setCurrentAppData((prevState) => {
          const ttrims = getTrims(value);

          return {
            ...prevState,
            has_trims: ttrims.length > 0,
            has_cabs: hasCabSizes(value),
          };
        });
        setShowTrims(true);

        setTimeout(async function () {
          await runTrims(value);
        }, 10);
      } else {
        await runCheckNow(value, "", false);
      }
      return;
    }

    setCurrentAppData((prevState) => {
      return { ...prevState, check: undefined, trim: "", has_trims: false };
    });
  }

  const handleModelChange = async (e) => {
    runHandleModelChange(e.target.value);
  };

  const handleTrimChange = async (e) => {
    setCurrentAppData((prevState) => {
      const cabSizes = getCabSizes(currentAppData?.model, e.target.value);
      console.log(
        "handleTrimChange",
        e.target.value,
        cabSizes,
        cabSizes.length,
      );
      return { ...prevState, cab: cabSizes.length == 1 ? cabSizes[0] : "" };
    });
    console.log("handleTrimChange", currentAppData);
    await runCheckNow(currentAppData?.model, e.target.value, true);
    //
    // const check = await runCheck(currentAppData?.model, e.target.value);
    // if (check.compatibility === 'N') {
    //     //alert('Need to get custom product via graphql and show the options for custom product');
    //     const product = await getCustomProduct(currentAppData?.model, e.target.value);
    //     product.images = currentAppData?.originalProduct?.images;
    //     await setCurrentAppData(prevState => {
    //         return { ...prevState, product: product }
    //     });
    //     return;
    // }
  };
  const handleCabSizeChange = async (e) => {
    await runCheckNowWithCabSize(
      currentAppData?.model,
      currentAppData?.trim,
      e.target.value,
      true,
      true,
    );
  };

  const handleClickChange = (e) => {
    setTrims([]);
    setShowTrims(false);
    setCurrentAppData((prevState) => {
      return {
        ...prevState,
        step: 1,
        year: "",
        make: "",
        model: "",
        trim: "",
        cab: "",
        has_trims: false,
        has_cabs: false,
        seat: "",
        color: "Black",
        addons: "",
        check: undefined,
      };
    });
  };

  const runCheck = async (model, trim, cabSize = "") => {
    const check = await fetchCheck(
      currentAppData?.year,
      currentAppData?.make,
      model,
      trim,
      currentAppData?.color,
      currentAppData?.seat,
      cabSize,
    );
    // console.log(`check result ${currentAppData?.year} ${currentAppData?.make} ${model} ${trim}`, check);
    let newStep = currentAppData?.step;
    if (
      (check.compatibility === "A" || check.compatibility === "N") &&
      check.compatibility_custom === "N"
    ) {
      newStep = 3;
      await setCurrentAppData((prevState) => {
        return {
          ...prevState,
          check: check,
          trim: trim,
          step: newStep,
          has_cabs: hasCabSizes(currentAppData.model),
        };
      });
      return check;
    }
    await setCurrentAppData((prevState) => {
      return {
        ...prevState,
        check: check,
        trim: trim,
        has_cabs: hasCabSizes(currentAppData.model),
      };
    });
    return check;
  };

  const getCustomProduct = (value: string | undefined, trim: string) => {
    custom_refetch();
    // console.log('getCustomProduct data', custom_data);

    return custom_data;
  };

  useEffect(() => {
    if (!currentAppData?.model) return;

    // console.log('useEffect model');

    async function runEffect() {
      if (
        currentAppData?.year &&
        currentAppData?.make &&
        currentAppData?.model
      ) {
        await runHandleModelChange(currentAppData?.model);

        if (currentAppData?.has_trims) {
          // console.log('test: ', typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData?.model].length > 0);
          setShowTrims(
            typeof trims[currentAppData.model] !== "undefined" &&
              trims[currentAppData?.model].length > 0,
          );
        } else {
          // run check
          //            runCheckNow(currentAppData?.model, '', false);
        }
        return;
      }
      setCurrentAppData((prevState) => {
        return { ...prevState, check: undefined, trim: "", has_trims: false };
      });
    }

    runEffect();
  }, [currentAppData?.model, trims]);

  /*useEffect(() => {
        if (!currentAppData?.trim || currentAppData?.trim === '')
            return;

        runCheckNow(currentAppData?.model, currentAppData?.trim, true);

    }, [currentAppData?.trim]);*/

  // console.log('trims', trims, currentAppData?.model, showTrims, trims && currentAppData?.model && showTrims)

    // console.log(
    //     'makesQuery', makesQuery, makesQuery?.data, disabledMakes
    // );

  return (<>

    <section
      className={`${styles.section__step} ${window.scs_custom_style ? styles.style01 : ""} ${currentAppData?.step == 1 ? styles.section_active : ""} 
      ${window.scs_black_friday_2025 ? styles.has_bf_2025: ''}`}
      id="step_1"
    >
      <h2>
        Step 1/3 - <strong>Vehicle Details</strong>
      </h2>
      {currentAppData?.step === 1 ? (
        <>
            <SuperOffer></SuperOffer>
          <div
            className={`${styles.vehicle_selector} ${showTrims ? styles.has_trims : ""}`}
          >
            <select
                id={`${props.id}-vehicle-year`}
                name="vehicle-year"
              onChange={handleYearChange}
              defaultValue={currentAppData?.year}
              data-selected={currentAppData?.year}
            >
              <option value="">Year</option>
              {yearsQuery.data &&
                yearsQuery.data.map((year, i) => {
                  return (
                    <option
                      key={`opt-${props.id}-${year}`}
                      value={`${slugify(year)}`}
                      selected={currentAppData?.year == year}
                    >
                      {year}
                    </option>
                  );
                })}
            </select>
            <select
                id={`${props.id}-vehicle-make`}
                name="vehicle-make"
              onChange={handleMakeChange}
              disabled={disabledMakes}
              defaultValue={currentAppData?.make}
              data-selected={currentAppData?.make}
            >
              <option value="">Make</option>
              {window.scs_use_optgroup ? (
                <>
                  <optgroup label="Top Sellers">
                    {makesQuery &&
                      makesQuery.data &&
                      makesQuery.data
                        .filter((v) => v.trim() != "")
                        .slice(0, 5)
                        .map((make, i) => {
                          return (
                            <option
                              key={`opt-${slugify(make)}`}
                              value={`${make}`}
                              selected={currentAppData?.make == make}
                            >
                              {make}
                            </option>
                          );
                        })}
                  </optgroup>
                  <optgroup label="All Others">
                    {makesQuery &&
                      makesQuery.data &&
                      makesQuery.data
                        .filter((v) => v.trim() != "")
                        .slice(5)
                        .map((make, i) => {
                          return (
                            <option
                              key={`opt-${props.id}-${slugify(make)}`}
                              value={`${make}`}
                              selected={currentAppData?.make == make}
                            >
                              {make}
                            </option>
                          );
                        })}
                  </optgroup>
                </>
              ) : (
                makesQuery &&
                makesQuery.data &&
                makesQuery.data.map((make, i) => {
                  return (
                    <option
                      key={`opt-${slugify(make)}`}
                      value={`${make}`}
                      selected={currentAppData?.make == make}
                    >
                      {make}
                    </option>
                  );
                })
              )}
            </select>
            <select
                id={`${props.id}-vehicle-model`}
                name="vehicle-model"
              onChange={handleModelChange}
              disabled={disabledModels}
              defaultValue={getDefaultModel(
                currentAppData,
                currentAppData?.model,
                modelsQuery,
              )}
            >
              <option value="">Model</option>
              {window.scs_use_optgroup ? (
                <>
                  <optgroup label="Top Sellers">
                    {modelsQuery &&
                      modelsQuery.data &&
                      modelsQuery.data.slice(0, 5).map((model, i) => {
                        return (
                          <option
                            key={`opt-${slugify(model)}`}
                            value={`${model}`}
                            selected={currentAppData?.model == model}
                          >
                            {model}
                          </option>
                        );
                      })}
                  </optgroup>
                  <optgroup label="All Others">
                    {modelsQuery &&
                      modelsQuery.data &&
                      modelsQuery.data.slice(5).map((model, i) => {
                        return (
                          <option
                            key={`opt-${slugify(model)}`}
                            value={`${model}`}
                            selected={currentAppData?.model == model}
                          >
                            {model}
                          </option>
                        );
                      })}
                  </optgroup>
                </>
              ) : (
                modelsQuery &&
                modelsQuery.data &&
                modelsQuery.data.map((model, i) => {
                  return (
                    <option
                      key={`opt-${slugify(model)}`}
                      value={`${model}`}
                      selected={currentAppData?.model == model}
                    >
                      {model}
                    </option>
                  );
                })
              )}
            </select>
            {trims && currentAppData.model && showTrims ? (
              <select id={`vehicle-trim`} onChange={handleTrimChange}>
                <option value="">Trim</option>
                {trims &&
                  typeof trims[currentAppData.model] !== "undefined" &&
                  getTrims(currentAppData?.model).map((obj, i) => {
                    const trim = obj;
                    return (
                      <option
                        key={`opt-${slugify(trim)}`}
                        value={`${trim}`}
                        selected={
                          trims[currentAppData?.model].length === 1 ||
                          currentAppData?.trim == trim
                        }
                      >
                        {trim}
                      </option>
                    );
                  })}
              </select>
            ) : (
              ""
            )}
            {trims &&
            currentAppData.model &&
            showTrims &&
            hasCabSizes(currentAppData.model) ? (
              <select id={`vehicle-cab-size`} onChange={handleCabSizeChange}>
                <option value="">Cab Size</option>
                {trims &&
                  typeof trims[currentAppData.model] !== "undefined" &&
                  getCabSizes(currentAppData?.model, currentAppData?.trim).map(
                    (cabSize, i) => {
                      return (
                        <option
                          key={`opt-${slugify(cabSize)}`}
                          value={`${cabSize}`}
                          selected={
                            getCabSizes(
                              currentAppData?.model,
                              currentAppData?.trim,
                            ).length === 1 || currentAppData?.cab == cabSize
                          }
                        >
                          {cabSize}
                        </option>
                      );
                    },
                  )}
              </select>
            ) : (
              ""
            )}
          </div>
          {!window.scs_force_custom && currentAppData.check && currentAppData.check?.alert ? (
            <div className={`${styles.vehicle_alert}`}>
              <strong>Warning:</strong> {currentAppData.check?.alert}
            </div>
          ) : (
            ""
          )}
          {window.scs_step_1_bottom_text ? (
            <div
              className={`${styles.bottom_text}`}
              dangerouslySetInnerHTML={{
                __html: `${window.scs_step_1_bottom_text}`,
              }}
            ></div>
          ) : (
            ""
          )}
        </>
      ) : (
        <div className={`${styles.summary}`}>
          <div
            className={`${styles.selected_value}`}
          >{`${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}${currentAppData?.trim ? " " + currentAppData?.trim : ""}${currentAppData?.cab ? " " + currentAppData?.cab : ""}`}</div>
          <button
            className={`${styles.btn_change}`}
            onClick={handleClickChange}
          >
            Change Vehicle
          </button>
        </div>
      )}
    </section></>
  );
}
